import { inject, singleton } from "tsyringe";
import {
  AdsContext,
  ContextRepository,
  FandomContextGroups,
} from "@identity/utils";
import { COOKIES } from "@identity/symbols";

@singleton()
export class CoppaSubject {
  coppaSubject: boolean | undefined;

  constructor(
    @inject(ContextRepository)
    private readonly contextRepository: ContextRepository,
    @inject(AdsContext) private readonly context: AdsContext,
    @inject(COOKIES) private readonly cookiesManager: CookiesManager,
  ) {}

  setIsCoppaSubjectInContext(isCoppaSubject: boolean): void {
    this.coppaSubject = isCoppaSubject;
    this.contextRepository.set(
      FandomContextGroups.partners,
      "directedAtChildren",
      isCoppaSubject,
    );
    this.contextRepository.set(FandomContextGroups.partners, "blockthrough", {
      directedAtChildren: isCoppaSubject,
    });
  }

  isCoppaSubject(): boolean {
    if (this.coppaSubject === undefined) {
      return this.resolveCoppaStatus();
    }
    return this.coppaSubject;
  }

  resolveCoppaStatus(): boolean {
    const wikiDirectedAtChildren = Boolean(
      this.context.get()?.targeting?.directedAtChildren,
    );

    if (!wikiDirectedAtChildren) {
      this.setIsCoppaSubjectInContext(false);
      return false;
    }

    const ageGateResult = this.cookiesManager.get("ag");
    const isCoppaSubject = ageGateResult !== "1";
    this.setIsCoppaSubjectInContext(isCoppaSubject);
    return isCoppaSubject;
  }
}
